{
  "visHjelpeskuffAriaLabel": "Gå til hjelp om dette.",
  "unknownError": "Ein feil har oppstått",
  "unknownErrorAction": "Last sida på nytt!",
  "pendingChangesHeader": "Det finst endringar som ikkje er lagra",
  "pendingChangesClose": "Forkast endringar",
  "pendingChangesConfirm": "Hald fram redigering",
  "pendingChangesDescription": "Dersom du forlet sida, vil du miste alle endringar du har gjort.",
  "languageChanged": "Språk endra til nynorsk",
  "breadCrumb_Forsiden": "Forside",
  "pageNotFoundHeader": "Denne sida er visst ikkje heilt frisk",
  "pageNotFoundDescription": "Sjå etter ein skrivefeil i URL-adressa, eller gå til framsida.",
  "pageNotFoundToStart": "Gå til framsida",
  "sharing_Status_Delt_Med_Barnet": "Delt med barnet",
  "sharing_Status_Bare_Synlig_For_Deg": "Berre synleg for deg",
  "word_explanation_open": "Opne ordforklaring",
  "word_explanation_close": "Lukk ordforklaring",
  "word_explanation_search_description": "Ser du ord eller uttrykk som du ikkje forstår, kan du søke her.",
  "word_explanation_search_input_label": "Søk",
  "word_explanation_search_submit_button": "Søk",
  "word_explanation_search_source_prefix": "Kjelde:",
  "language_norwegian": "Norsk",
  "language_english": "English",
  "language_sami": "Sámi",
  "language_nynorsk": "Nynorsk",
  "language_lithuanian": "Lietuviškai",
  "language_polish": "Polski",
  "language_russian": "Русский",
  "language_romanian": "Română",
  "visHjelpeskuffTekst": "Meir hjelp",
  "breadcrumb_arialabel": "Brødsmulesti",
  "language_picker_trigger_text": "Språk/Language",
  "language_ukrainian": "Українська",
  "language_french": "Français",
  "word_explanation_search_container_label": "Ordforklaringar",
  "driftspanel_aria_label": "Driftsmeldinger",
  "sharing_Status_Skjult_For_Barnet": "Skjult for barnet",
  "sharing_Status_Skjult_For_Fullmektig": "Skjult for fullmektig"
}
